<template>
  <div class="posts-container">
    <div class="posts-body">
      <div class="body-title">
        <div class="title">{{ title }}</div>
      </div>
      <div class="img-mode" v-if="form.type == 1">
        <div class="left-part">
          图片编辑<span>({{ form.image_list.length }}/16)支持拖拽排序</span>
        </div>
        <div class="right-part" @click="onClearClick">清空并重新上传</div>
      </div>
      <div class="body-content" v-show="form.type>0">
        <div class="left-content" v-if="form.type == 0"></div>
        <div class="left-content" v-if="form.type == 1">
          <div class="img-box">
            <div class="img-box-item" v-if="form.image_list.length < 16">
              <Upload
                class="img-upload-btn"
                :action="upload_url"
                :data="{ dir: 'template' }"
                multiple
                :before-upload="onBeforeUpload"
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'img_list')
                "
                :show-upload-list="false"
                :format="['jpg', 'jpeg', 'png', 'gif']"
                accept=".jpg,.jpeg,.png,.gif"
                @click.prevent.stop="up_type='img_list'"
              >
                <template>
                  <img
                    class="icon-upload"
                    src="../../assets/images/icon-add-posts.png"
                  />
                </template>
              </Upload>
            </div>
            <div
              v-for="(item, index) in form.image_list"
              draggable
              @dragstart="handleDragStart($event, index)"
              @dragover.prevent
              @drop="handleDrop($event, index)"
              class="img-box-item"
              :key="index"
            >
              <div class="img-box-item-content">
                <img :src="item | default_img" alt="" v-viewer />
                <div class="img-exchange" @click="onImgExchange(index)">
                  替换
                </div>
                <div class="del-icon" @click="onDeleteImg(index)"></div>
              </div>
              <input
                type="file"
                :ref="'fileInput' + index"
                style="display: none"
                accept="image/*"
                @change="handleExchangeFile($event, index)"
              />
            </div>
          </div>
        </div>
        <div class="left-content" v-if="form.type == 2">
          <video
            :src="form.video"
            ref="ffv"
            controls
            class="preview-video"
          ></video>
          <div class="video-info">
            <div class="file-title">
              <div class="title">{{ form.media_info.name }}</div>
              <Upload
                :action="upload_url"
                :data="{ dir: 'template' }"
                multiple
                :before-upload="onBeforeUpload"
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'video')
                "
                :show-upload-list="false"
                :format="['mp4', 'mov']"
                accept=".mp4,.mov"
                @click="up_type='video'"
              >
                <template>
                  <div class="change-video-btn">替换视频</div>
                </template></Upload
              >
            </div>
            <div class="file-info">
              <img
                src="../../assets/images/icon-upload-success-posts.png"
                class="upload-success-icon"
              />
              <div class="upload-status">上传成功</div>
              <div class="file-size">
                视频大小：{{ form.media_info.file_size }}
              </div>
              <div class="file-time">
                视频时长：{{ (form.media_info.duration || 0).toFixed(2) }}s
              </div>
            </div>
          </div>
          <div class="video-cover-img">
            <Upload
              class="cover-img"
              :action="upload_url"
              :data="{ dir: 'template' }"
              multiple
              :before-upload="onBeforeUpload"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'cover')
              "
              :show-upload-list="false"
              :format="['jpg', 'jpeg', 'png', 'gif','webp']"
              accept=".jpg,.jpeg,.png,.gif,.webp" @click="up_type='cover'"
            >
              <img
                :src="form.cover | default_img"
                :class="[form.cover ? 'img-had-upload' : 'empty-img']"
              />
              <div class="upload-btn"></div>
            </Upload>
            <div class="cover-img-explain">
              <div class="set-cover">封面设置</div>
              <div class="explain-desc">
                默认截取第一帧作为封面,优秀的封面会吸引更多人浏览
              </div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="form-content">
            <Form label-position="top">
              <FormItem label="正文内容" required>
                <div class="content-title">
                  <input
                    style="padding-right: 17%"
                    v-model="form.title"
                    maxlength="20"
                    placeholder="填写一个好的标题会有更多赞哦~"
                  />
                  <div class="input-suffix">{{ form.title.length }}/20</div>
                </div>
                <div class="content-area" style="position: relative">
                  <div
                    ref="editable"
                    class="input-area"
                    :contenteditable="true"
                    @blur="onContentEditableBlur"
                    @input="onInput"
                    @keydown="onKeydown"
                    @click="onClick"
                    @paste="handlePaste"
                    data-placeholder="输入正文描述,真诚有价值的更能让人喜欢"
                  ></div>
                  <template v-if="filteredOptions.length > 0">
                    <div
                      class="dropdown"
                      v-if="showDropdown"
                      :style="{ top: dropdownY + 'px', left: dropdownX + 'px' }"
                    >
                      <div
                        v-for="(item, index) in filteredOptions"
                        :key="`tags-${item.id}`"
                        @mousedown.prevent="selectItem(item)"
                        :class="{ selected: index === currentIndex }"
                        @mouseenter="currentIndex = index"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </template>
                  <div class="count-area">{{ currentTextLength }}/5000</div>
                </div>
                <div class="topic-emoji-box">
                  <div class="topic" @click="handleTopicClick">
                    <span class="topic-btn">#话题标签</span>
                  </div>
                  <!-- <div class="emoji"><span class="btn-icon"></span>表情</div> -->
                  <emoji-picker @emoji="append">
                    <button
                      ref="emojiInvokerBtn"
                      class="emoji"
                      slot="emoji-invoker"
                      slot-scope="{ events: { click: clickEvent } }"
                      @click.prevent.stop="
                        ($event) => {
                          clickEvent($event);
                          handleEmojiButtonClick();
                        }
                      "
                    >
                      <span class="btn-icon"></span>表情
                    </button>

                    <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                      <div
                        class="emoji-picker"
                        :style="{
                          position: 'absolute',
                        }"
                      >
                        <!-- Emoji 内容 -->
                        <div
                          v-for="(emojiGroup, category) in emojis"
                          :key="category"
                        >
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insert(emoji)"
                              :title="emojiName"
                              >{{ emoji }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </emoji-picker>
                </div>
              </FormItem>
              <FormItem label="分类" required>
                <Select
                  v-model="form.category_id"
                  placeholder="请选择笔记分类"
                  placement="top"
                  size="large"
                >
                  <!-- <Option value=""></Option> -->
                  <Option
                    v-for="(item, index) in cate_list"
                    :value="item.id"
                    :key="index"
                    >{{ item.cate_name }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem label="可见范围" required>
                <Select
                  v-model="form.purview"
                  :value="form.purview"
                  placement="top"
                  size="large"
                >
                  <!-- <Option value=""></Option> -->
                  <Option
                    v-for="(item, index) in permissions"
                    :value="item.value"
                    :key="index"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem label="发布时间">
                <div class="publish-type">
                  <div style="width: 100%; margin-bottom: 20px">
                    <RadioGroup v-model="form.publish_type" vertical>
                      <Radio label="0">立即发布</Radio>
                      <Radio label="1">定时发布</Radio>
                    </RadioGroup>
                  </div>
                  <DatePicker
                    v-if="form.publish_type == '1'"
                    placeholder="请选择发布时间"
                    placement="top-end"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :value="form.publish_time"
                    :options="dateOptions"
                    @on-change="handleDateChange"
                  >
                  </DatePicker>
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-bottom">
      <div class="bottom-btn-box">
        <div
          class="draft-box"
          @click="$router.push({ name: 'MyCreations', query: { type: '2' } })"
        >
          草稿箱
        </div>
        <Button
          @click="onSubmit('temp')"
          class="temp-save-btn"
          type="default"
          :disabled="submit_debounce"
          >暂存草稿箱</Button
        >
        <Button
          @click="onSubmit('submit')"
          class="submit"
          :disabled="submit_debounce"
          >发布</Button
        >
      </div>
    </div>
    <video style="display: none" ref="video" muted></video>
    <canvas style="display: none" ref="canvas"></canvas>
  </div>
</template>
<script>
import { GetCategoryList } from "@/api/index";
import {
  GetPostsByUUID,
  EditPosts,
  GetTopicListByKeyWord,
  CreateTopic,
} from "@/api/social";
import videoMixin from "@/mixins/video";
import { EmojiPicker } from "vue-emoji-picker";
import { uploadFileToOSS } from "@/utils/oss";
import dayjs from 'dayjs'
export default {
  data() {
    return {
      form: {
        title: "",
        content: "",
        rich_content: "",
        image_list: [],
        category_id: "",
        video: "",
        cover: "",
        publish_type: "0",
        publish_time: "",
        type: 0,
        topic: [],
        uuid: "",
        media_info: {},
        purview:0,
      },
      editable: null,
      showDropdown: false,
      dropdownX: 0,
      dropdownY: 0,
      triggerText: "",
      tag_list: [],
      cate_list: [],
      filteredOptions: [],
      currentIndex: -1, // 新增：记录当前选中项索引
      currentTextLength: 0,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      submit_debounce: false,
      isInsertingTag: false,
      debounceTimer: null,
      savedRange: null,
      permissions:[
        {name:"公开可见",value:0},
        {name:'仅自己可见',value:1},
        {name:'仅互关好友可见',value:2}
      ],
      up_type:"",
      dateOptions: {
        // 1. 固定禁用日期（仅禁用今天之前的日期，今天可选）
        disabledDate(date) {
          // 获取今天零点的毫秒时间戳
          const today = new Date().setHours(0, 0, 0, 0);
          // 禁用今天之前的所有日期
          return date && date.getTime() < today;
        }
      },
    };
  },
  components: {
    EmojiPicker,
  },
  mixins: [videoMixin],
  watch: {
    filteredOptions() {
      this.currentIndex = -1; // 当过滤选项变化时重置选中状态
    },
    "form.content"(newVal, oldVal) {
      this.currentTextLength = newVal.length;
    },
    "form.image_list"(newVal, oldVal) {
    },
    "form.publish_time"(newVal, oldVal) {
      console.log("new", newVal, "old", oldVal);
    },
    dropdownX(newVal, oldVal) {
    },
    up_type(newVal,oldVal){
      console.log('newVal',newVal);
      console.log('oldVal',oldVal);
    }
  },
  computed: {
    title() {
      return this.form.type > 0 ? (this.form.type == "1" ? "上传图文" : "发布视频") : "";
    },
    is_login() {
      return this.$store.state.is_login;
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log("param", to);
    const { uuid } = to.params;
    if (uuid) {
      this.form.uuid = uuid;
      this.onGetPosts();
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      console.log("aaa");
      vm.$emit("showFooter", false);
    });
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
  mounted() {
    if (!this.is_login) {
      this.$router.replace({ name: "Login" });
      return;
    }
    const { uuid } = this.$route.params;
    if (uuid) {
      this.form.uuid = uuid;
      this.onGetPosts();
    }
    this.editable = this.$refs.editable;
    this.onGetCate();
  },
  created() {
    if (!this.editable) {
      this.editable = this.$refs.editable;
    }
  },
  methods: {
    onContentEditableBlur(e){
      this.showDropdown = false;
    },
    handlePaste(event) {
      event.preventDefault(); // 阻止默认粘贴行为

      const clipboardData = event.clipboardData || window.clipboardData;
      let pastedData;

      if (clipboardData && clipboardData.getData) {
        pastedData = clipboardData.getData("text/html"); // 获取 HTML 数据
      } else if (event.originalEvent && event.originalEvent.clipboardData) {
        pastedData = event.originalEvent.clipboardData.getData("text/html");
      }

      let parsedHTML = "";

      if (pastedData) {
        // 如果有 HTML 数据，则直接使用
        parsedHTML = pastedData;
      } else {
        // 否则获取纯文本并转换为 HTML
        const text = clipboardData.getData("text/plain");
        parsedHTML = document.createTextNode(text).outerHTML || text;
      }

      // 插入解析后的 HTML 到 contenteditable 元素中
      document.execCommand("insertHTML", false, parsedHTML);

      // 同步数据到表单字段
      this.form.content = this.$refs.editable.textContent.trim();
      this.form.rich_content = this.$refs.editable.innerHTML;
    },
    handleEmojiButtonClick() {
      const editable = this.$refs.editable;
      if (editable) {
        console.log("aaa-edit");
        editable.focus();
        this.saveCurrentSelection(); // 可选：保存当前光标位置
      }
    },
    saveCurrentSelection() {
      const selection = window.getSelection();
      if (!selection.rangeCount) return;

      this.savedRange = selection.getRangeAt(0); //保存当前选区范围
    },
    clickEvent(e) {
      console.log("clickEvent", e);
      const editable = this.$refs.editable;
      if (editable) {
        editable.focus();
        this.saveCurrentSelection(); //点击时保存光标位置
      }
    },
    append(emoji) {
      console.log("emoji", emoji);
      const editable = this.$refs.editable;
      if (!editable) return;

      editable.focus();

      let range = this.savedRange; //使用之前保存的光标位置
      if (!range && window.getSelection().rangeCount > 0) {
        range = window.getSelection().getRangeAt(0); //如果没有保存过，则使用当前光标位置
      }

      if (!range) return;

      range.deleteContents(); // 删除已选内容（如果有）

      const emojiTextNode = document.createTextNode(emoji);
      range.insertNode(emojiTextNode);

      //将光标放在插入的 Emoji 后面
      range.setStartAfter(emojiTextNode);
      range.setEndAfter(emojiTextNode);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      //同步数据到表单字段
      this.form.content = editable.innerText;
      this.form.rich_content = editable.innerHTML;
    },
    async onGetTopicList(keyword) {
      try {
        const { data } = await GetTopicListByKeyWord({ keyword });
        return data;
      } catch (e) {
        console.log("e-topic", e);
        return [];
      }
    },
    async onBeforeUpload(file) {
      // console.log('替换视频触发');
      const field = this.up_type;
      // console.log("file-before", file);
      // console.log('field',field);
      // console.log('this.form.type',this.form.type);
      if (this.form.type == 2) {
        // console.log('上传的是视频',file);
        this.video_info.name = file.name;
        await this.onVideoExcute(file);
      }
      this.handleUpload(file, field);
      return false;
    },
    async handleUpload(file, field) {
      try {
        const url = await uploadFileToOSS(file, 'template');
        // console.log('url-handle-upload',url);
        if (field === 'img_list') {
          this.form.image_list.push(url);
        } else if (field === 'cover') {
          this.form.cover = url;
        } else if (field === 'video') {
          this.form.video = url;
        }
      } catch (err) {
        this.$layer.msg('上传失败：' + err.message);
      }
    },
    async onGetCate() {
      const { data } = await GetCategoryList();
      this.cate_list = data;
    },
    handleDateChange(value) {
      this.form.publish_time = value;
    },
    removeEmptySpans(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const spans = doc.querySelectorAll("span");

      spans.forEach((span) => {
        // 判断是否为空或只有空格
        if (!span.hasChildNodes() || span.textContent.trim() === "") {
          // 用子节点替换当前 span（将子节点提到父级）
          while (span.firstChild) {
            span.parentNode.insertBefore(span.firstChild, span);
          }
          span.remove(); // 移除空 span
        }
      });

      return doc.body.innerHTML;
    },
    async onGetPosts() {
      let plainText = "";
      const { uuid } = this.form;
      const { data } = await GetPostsByUUID({ uuid });
      console.log("data-get-by-uuid", data);
      if (data.content) {
        this.$refs.editable.innerHTML = this.removeEmptySpans(data.content);

        const tags = this.$refs.editable.querySelectorAll(".tag");
        tags.forEach((tag) => {
          tag.setAttribute("contenteditable", true);
        });

        const parser = new DOMParser();
        const contentElement = this.$refs.editable;
        const doc = parser.parseFromString(
          contentElement.innerHTML,
          "text/html"
        );
        plainText = doc.body.textContent.trim();
      }
      // this.$set(this.form,{},data);
      this.form = {
        title: data.title || "",
        content: plainText || "",
        rich_content: data.content || "",
        video: data.video || "",
        cover: data.cover || "",
        category_id: data.category_id || "",
        publish_type: data.publish_type.toString() || "",
        publish_time: data.publish_time || "",
        type: data.type,
        image_list: data.image_list || [],
        topic: data.topic || [],
        uuid: data.uuid,
        media_info: data.media_info || {},
        purview:data.purview || 0
      };
    },
    removeFontTags(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const fonts = doc.querySelectorAll("font");

      fonts.forEach((font) => {
        while (font.firstChild) {
          font.parentNode.insertBefore(font.firstChild, font);
        }
        font.remove();
      });

      return doc.body.innerHTML;
    },
    async onSubmit(creation) {
      const now = new dayjs()
      const targetTime = dayjs(this.form.publish_time);
      if(this.form.publish_type == 1 && this.form.publish_time && now.isAfter(targetTime)) {
        this.$layer.msg("发布时间不可早于当前时间");
        return
      }

      if (this.submit_debounce){
        console.warn("触发重复提交");
        return;
      }
      // console.log('触发提交');
      // return;

      const editableDiv = this.$refs.editable;
      const tags = editableDiv.querySelectorAll(".tag");
      tags.forEach((tag) => {
        tag.removeAttribute("contenteditable");
      });

      //>替换换行符为<br>
      const replaceNewlinesWithBr = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;

        //>遍历所有子节点
        const walk = (node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            if (text.includes("\n")) {
              const fragment = document.createDocumentFragment();
              const parts = text.split("\n");
              parts.forEach((part, index) => {
                if (index > 0)
                  fragment.appendChild(document.createElement("br"));
                if (part) fragment.appendChild(document.createTextNode(part));
              });
              node.replaceWith(fragment);
            }
          } else {
            Array.from(node.childNodes).forEach(walk);
          }
        };

        walk(div);
        return div.innerHTML;
      };

      const processedHTML = replaceNewlinesWithBr(editableDiv.innerHTML);

      this.form.rich_content = this.removeFontTags(processedHTML);

      const {
        title,
        content,
        rich_content,
        video,
        cover,
        category_id,
        publish_type,
        publish_time,
        type,
        image_list,
        topic,
        uuid,purview
      } = this.form;
      if(creation == 'submit'){
      let validate_res = false;
      switch (true) {
        case !title:
          this.$layer.msg("请填写标题");
          validate_res = true;
          break;
        case !content:
          this.$layer.msg("请填写正文内容");
          validate_res = true;
          break;
        case !category_id:
          this.$layer.msg("请选择笔记分类");
          validate_res = true;
          break;
        case publish_type == "1" && !publish_time:
          validate_res = true;
          this.$layer.msg("请选择发布时间");
          break;
        case type == "1" && (!image_list.length || image_list.length < 1):
          validate_res = true;
          this.$layer.msg("请至少上传一张图片");
          break;
        case type == "2" && !video:
          validate_res = true;
          this.$layer.msg("请上传视频");
          break;
        case type == "2" && !cover:
          this.$layer.msg("请上传视频封面");
          validate_res = true;
          break;
      }

      if (validate_res) {
        return false;
      }
    }

      if (this.currentTextLength > 5000) {
        this.$layer.msg("字数不能超过5000字");
        return;
      }

      try {
        let status = -1;
        if (creation === "submit") {
          status = 0;
        }
        console.log("param", {
          title,
          content,
          rich_content,
          video,
          cover,
          category_id,
          publish_type,
          publish_time,
          type,
          image_list,
          topic,
          status,
          uuid,
          purview
        });

        // return;

        this.submit_debounce = true;
        const { data } = await EditPosts({
          title,
          content,
          rich_content,
          video,
          cover,
          category_id,
          publish_type,
          publish_time,
          type,
          image_list,
          topic,
          status,
          uuid,purview
        });
        console.log("data", data);
        const res = data;
        const uid = res.uuid;
        this.onClearClick();
        this.$layer.msg(creation == "submit" ? "发布成功" : "保存成功");

        await this.$router.replace({
          name: "MyCreations",
          query: { uuid,type:status == -1 ? 2:1 },
        });
        // await this.$router.replace({
        //   name: "Posts",
        //   params: { uuid: uid },
        // });
      } catch (e) {
        console.log("err", e);
        this.$layer.msg(e.msg);
      } finally {
        setTimeout(()=>{
          this.submit_debounce = false;
        },1000);
      }
    },
    onImgExchange(index) {
      const input = this.$refs["fileInput" + index][0];
      if (input) {
        input.value = null;
        input.click();
      }
    },

    handleExchangeFile(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      this.uploadImage(file, index);
    },

    async uploadImage(file, index) {
      try {
        // const response = await uploadFile(file, "template");
        const url = await uploadFileToOSS(file);
        console.log('url',url);
        this.$set(this.form.image_list, index, url);
        this.$layer.msg("图片替换成功");
      } catch (error) {
        this.$layer.msg("上传失败，请检查网络");
      }
    },
    onDeleteImg(index) {
      this.form.image_list.splice(index, 1);
    },
    onClearClick() {
      this.form = {
        title: "",
        content: "",
        rich_content: "",
        image_list: [],
        category_id: "",
        video: "",
        cover: "",
        publish_type: "0",
        publish_time: "",
        type: 1,
        image_list: [],
        topic: [],
        uuid: "",
        media_info: {},
      };
      this.editable.innerHTML = "";
    },
    handleDragStart(event, draggedIndex) {
      event.dataTransfer.setData("draggedIndex", draggedIndex);
    },

    handleDrop(event, targetIndex) {
      event.preventDefault();
      const draggedIndex = event.dataTransfer.getData("draggedIndex");

      if (draggedIndex === targetIndex) return;

      const draggedItem = this.form.image_list.splice(draggedIndex, 1)[0];
      this.form.image_list.splice(targetIndex, 0, draggedItem);
    },
    handleSuccess(response, file, fileList, field) {
      const length = this.form.image_list.length;
      if (length >= 16) {
        this.$layer.msg("最多上传16张图片");
        return;
      }
      if (field === "img_list") {
        this.form.image_list.push(response.data.url);
      } else if (field === "cover") {
        this.$set(this.form, "cover", response.data.url);
      } else {
        this.$set(this.form, field, response.data.url);
        const videInfo = this.$_.cloneDeep(this.video_info);
        const { cover, file_size, duration } = videInfo;
        this.$set(this.form, "cover", cover);
        this.$set(this.form, "media_info", {
          file_size,
          duration,
          name: file.name,
        });
        console.log("this.form---", this.form);
      }
    },
    onTitleChange(e) {
      const { value } = e.target;
      if (value.length <= 20) {
        this.form.title = value;
      } else {
        this.$layer.msg("标题不能超过20个字符");
        this.form.title = value.slice(0, 20);
      }
      console.log("e-titleChange", e);
    },
    async handleTopicClick() {
      const editable = this.editable;
      const scrollTop = editable.scrollTop;
      editable.focus();

      this.editable.scrollTop = scrollTop;

      this.$nextTick(async () => {
        await this.insertHashAtEnd();
        await this.positionDropdownAtEnd();
        // this.getCaretPosition();
      });
    },
    insertHashAtEnd() {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(this.editable);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("insertText", false, "#");
    },
    positionDropdownAtEnd() {
      const { x, y } = this.getCaretPosition();
      this.dropdownX = x;
      this.dropdownY = y;
    },
    getCaretPosition() {
      const selection = window.getSelection();
      if (!selection.rangeCount) return { x: 0, y: 0 };

      const range = selection.getRangeAt(0).cloneRange();
      range.collapse(false);

      const dummy = document.createElement("span");
      range.insertNode(dummy);
      const rect = dummy.getBoundingClientRect();
      const { left, bottom } = rect;
      dummy.remove();

      return {
        x: left,
        y: bottom,
      };
    },

    async handleDebouncedSearch(triggerText) {
      this.tag_list = await this.onGetTopicList(triggerText);

      this.filteredOptions = this.tag_list.filter((opt) =>
        opt.title.includes(triggerText)
      );

      if (this.filteredOptions.length < 1) {
        this.filteredOptions = [{ id: "-1", title: triggerText }];
      }

      this.triggerText = triggerText;
      this.$nextTick(() => {
        const pos = this.getCaretPosition();
        this.dropdownX = pos.x;
        this.dropdownY = pos.y;
        this.showDropdown = true;
      });
    },
    async onInput() {
      const selection = window.getSelection();
      const node = selection.anchorNode;
      const offset = selection.anchorOffset;

      if (!node || node.nodeType !== Node.TEXT_NODE) {
        this.showDropdown = false;
        return;
      }

      // 新增：检测内容是否为空
      const content = this.$refs.editable.textContent.trim();
      this.form.content = content; // 同步表单数据
      this.form.rich_content = this.$refs.editable.innerHTML;

      // 新增：更新占位符显示状态
      if (content === "") {
        this.$refs.editable.style.opacity = "1"; // 确保元素可见
      }

      // 处理tag标签删除后topic数组不更新导致无法重新插入标签的问题
      const tags = this.$refs.editable.querySelectorAll(".tag");
      const currentTopics = Array.from(tags).map((tag) => {
        const text = tag.textContent.trim().replace(/^#/, "");
        return text;
      });

      // 替换 form.topic 为当前仍存在的标签
      this.form.topic = currentTopics;

      const text = node.textContent.slice(0, offset);
      // const match = text.match(/#([\S]*)$/);
      const match = text.match(/#([\u4e00-\u9fa5a-zA-Z0-9_]*)$/u);

      if (match) {
        const triggerText = match[1];

        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
          this.handleDebouncedSearch(triggerText);
        }, 300);
      } else {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        this.showDropdown = false;
      }
    },
    onClick() {
      this.showDropdown = false;
    },
    onKeydown(e) {
      if (e.key === "Escape") {
        this.showDropdown = false;
      }
      if (this.showDropdown) {
        switch (e.key) {
          case "ArrowUp":
            this.moveUp();
            e.preventDefault();
            break;
          case "ArrowDown":
            this.moveDown();
            e.preventDefault();
            break;
          case "Enter":
            if (this.currentIndex !== -1) {
              this.selectItem(this.filteredOptions[this.currentIndex]);
            }
            e.preventDefault();
            break;
        }
      }
    },

    moveUp() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.filteredOptions.length - 1;
      }
    },

    moveDown() {
      if (this.currentIndex < this.filteredOptions.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    async selectItem(item) {
      const selection = window.getSelection();
      const node = selection.anchorNode;
      const offset = selection.anchorOffset;

      if (!node || node.nodeType !== Node.TEXT_NODE) return;

      const text = node.textContent;
      const before = text.slice(0, offset);
      const after = text.slice(offset);
      // const match = before.match(/#(\w*)$/);
      // if (!match) return;

      // 使用 triggerText 替代重新 match，避免匹配失败
      const matchIndex = before.lastIndexOf(`#${this.triggerText}`);

      if (matchIndex === -1) return;

      const prefix = before.slice(0, matchIndex);

      const tagsArr = this.form.topic;
      if (tagsArr.includes(item.title)) {
        this.$layer.msg("该话题已添加");
        return;
      }

      if (item.id == "-1") {
        await CreateTopic({ title: item.title });
      }

      // 创建新内容
      const newTextNode = document.createTextNode(" ");
      const tagSpan = document.createElement("span");
      tagSpan.className = "tag";
      tagSpan.style = "color:#104da1;cursor:pointer;";
      tagSpan.setAttribute(
        "onclick",
        `window.open('/search/${item.title}','_blank')`
      );
      tagSpan.textContent = `#${item.title}`;
      tagSpan.contentEditable = "true";

      const tailTextNode = document.createTextNode(after);

      // 替换原 node
      const parent = node.parentNode;
      const next = node.nextSibling;
      parent.removeChild(node);

      const insertPoint = next || null;
      parent.insertBefore(document.createTextNode(prefix), insertPoint);
      parent.insertBefore(tagSpan, insertPoint);
      parent.insertBefore(newTextNode, insertPoint);
      parent.insertBefore(tailTextNode, insertPoint);

      // 设置光标在 tailTextNode 开头
      const newRange = document.createRange();
      newRange.setStart(tailTextNode, 0);
      newRange.setEnd(tailTextNode, 0);
      selection.removeAllRanges();
      selection.addRange(newRange);

      // 👇 新增：恢复滚动位置
      const scrollTop = this.editable.scrollTop;
      this.$nextTick(() => {
        this.editable.scrollTop = scrollTop;
      });

      this.showDropdown = false;
      this.currentIndex = -1;

      // 同步数据
      const content = this.$refs.editable.textContent.trim();
      this.form.content = content;
      this.form.rich_content = this.$refs.editable.innerHTML;
      this.form.topic.push(item.title);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./posts.scss";
</style>
